const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/aths854c6d8x-UZ/image;s=644x461",
        title: "Беспроводные наушники Xiaomi Redmi AirDots 3",
        price: "45 у.е.",
        location: "Ташкент, Юнусабадский район"
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/9e47yiyua0mz2-UZ/image;s=644x461",
        title: "Halol kredit konditsioner Hofmann GWH12AFC-K3NNA1E Muse Low Voltage",
        price: "525 у.е.",
        location: "Ташкент, Мирзо-Улугбекский район",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/ak06vos5nmkg1-UZ/image;s=644x461",
        title: "Samsung A52 Рассрочка (муддатли тулов), halol kredit",
        price: "4 515 000 сум",
        location: "Джизак",
    },
]

export default data;